import { useGetFlags } from '@/hooks/useFeatureFlag';

/** Env flag name: `FEATURE_FLAG_KEEP_APPROVAL_SEARCH_CONDITIONS` in `packages/apps/.env.*`. */
export const KEEP_APPROVAL_SEARCH_CONDITIONS_FLAG =
  'KEEP_APPROVAL_SEARCH_CONDITIONS';

/**
 * NA-5815 / NA-5831: keep the Approval-list search conditions across
 * Edit / Approve / Reject. Resolved through `useGetFlags`, like the other
 * env flags (suspends until the flag module answers, then cached per name).
 */
export const useKeepApprovalSearchConditionsFlag = (): boolean =>
  useGetFlags(KEEP_APPROVAL_SEARCH_CONDITIONS_FLAG);
